import Image from 'next/image';
import styles from '../../styles/modules/building/BuildingGreeting.module.scss';

const getAddress = (a) => {
  const arr = [];

  if (a['locality-name']) arr.push(a['locality-name']);
  if (a.address) {
    let add = a.address.replace(/\./g, '');

    if (add.slice(add.length - 1) === ',') add = add.slice(0, add.length - 1);
    if (add.slice(add.length - 2) === ', ') add = add.slice(0, add.length - 2);

    arr.push(add);
  }

  return arr.join(', ');
};
const getPrice = (p) => {
  const priceMin = Number((p.min / 1000000).toFixed(1));
  const priceMax = Number((p.max / 1000000).toFixed(1));

  if (priceMin === priceMax) {
    return `от ${priceMin} млн ₽`;
  }

  return `от ${priceMin} млн ₽ до ${priceMax} млн ₽`;
};

const BuildingGreeting = ({ name, image, price, location }) => {
  return (
    <section className={['block', styles.greeting].join(' ')}>
      <Image src={image} alt="" fill style={{ objectFit: 'cover' }} />
      <div className={styles.greetingOverlay} />
      <div className="fixed">
        <h1 className={styles.gretingTitle}>ЖК «{name}»</h1>
        <div className={styles.gretingSubtitle}>{getAddress(location)}</div>
        <div className={styles.gretingDescription}>{getPrice(price)}</div>
      </div>
    </section>
  );
};

export default BuildingGreeting;
